module.exports = __webpack_public_path__ + "static/media/scenery_triangle.1bf1e3af.png";